module.exports = __webpack_public_path__ + "media/assets/images/start_page/startpage_graphic_meeting-bc78a2e3cf7cfa7f8827d3a991ae1873.svg";